import { render, staticRenderFns } from "./BaseStripeIcon.vue?vue&type=template&id=2dc11648&scoped=true"
import script from "./BaseStripeIcon.vue?vue&type=script&lang=js"
export * from "./BaseStripeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc11648",
  null
  
)

export default component.exports